<template>
<div class="chapter">
<div class="inner_page">
<div class="iosnode"><h1 class="titlepage-title" id="A-157755_29">How to Read Tarot</h1>
<h2 class="titlepage-subtitle" id="A-157755_33">A Practical Guide</h2>
<p class="titlepage-imprintlogo" id="A-157755_37"><img alt="Adams Media logo" src="images/logo-adams.gif"/></p>
<p class="titlepage-imprintaddress" id="A-157755_41">Avon, Massachusetts</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// N157755.vue?48e10c05